module.exports = __webpack_public_path__ + "static/img/183_TO8_2037.a8dbd0d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/183_TO8_2037.jpg
// module id = Xzeb
// module chunks = 0